import Vue from "vue";
import Router from "vue-router";
// import Home from './views/Home.vue'
import FoodList from "./views/FoodList.vue";
import LadingPage from "./views/LandingPage.vue";
import RemoveData from "./views/RemoveData.vue";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "landing-page",
      component: LadingPage,
    },
    {
      path: "/app",
      name: "foodlist",
      component: FoodList,
    },
    {
      path: "/privacy",
      name: "remove-data",
      component: RemoveData,
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
    },
  ],
});
